import { useEffect, useState } from "react";

const ROW_HEIGHT = 64;

function PatientListFooter({ table, scrollRef }) {
    const totalRows = table.getRowCount();
    const [range, setRange] = useState({ start: 0, end: 0 });

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) {
            return;
        }

        // example calculation:
        // viewport height = 670, scroll position = 320px, row height = 64px, totalRows = 250
        // first = floor(320 / 64) = 5 (row 5)
        // last = ceil((320 + 670) / 64) = 16
        // start = 6, end = 16
        // display: "Showing 6-16 of 250 patients"
        const update = () => {
            if (totalRows === 0) {
                setRange({ start: 0, end: 0 });
                return;
            }

            const first = Math.floor(scrollContainer.scrollTop / ROW_HEIGHT);
            const last = Math.ceil(
                (scrollContainer.scrollTop + scrollContainer.clientHeight) /
                    ROW_HEIGHT
            );
            const start = first + 1;
            const end = Math.min(totalRows, Math.max(start, last));
            setRange((prev) =>
                prev.start === start && prev.end === end ? prev : { start, end }
            );
        };

        update();
        scrollContainer.addEventListener("scroll", update);
        window.addEventListener("resize", update);

        return () => {
            scrollContainer.removeEventListener("scroll", update);
            window.removeEventListener("resize", update);
        };
    }, [scrollRef, totalRows]);

    const shown =
        totalRows === 0
            ? "0"
            : range.start === range.end
              ? `${range.start}`
              : `${range.start}–${range.end}`;

    return (
        <div className="flex justify-end text-[13px] text-neutral-400">
            <span>
                Showing {shown} of {totalRows}{" "}
                {totalRows === 1 ? "patient" : "patients"}
            </span>
        </div>
    );
}

export default PatientListFooter;
